import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import language from "../../language";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchPatientLabResult = async (
  lng = "english",
  { page, limit, type, hospital, id, q, patient }
) => {
  try {
    const user = await getStorage();

    const options = {
      method: "GET",
      url: `${API_URL}/patient-lab-result`,
      params: {
        page: page,
        limit: limit,
        hospital,
        id,
        q,
        patient,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    if (type === "dropdown") {
      return queryRes.data.map((el) => {
        return {
          ...el,
          label: el.patientId + " - " + el.firstName + " " + el.lastName,
          value: el._id,
        };
      });
    }

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deletePatientLabResult = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const options = {
      method: "DELETE",
      url: `${API_URL}/patient-lab-result`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_data);
  } catch (error) {
    toastMessage("error", error);
  }
};
